import { atom, useRecoilState } from "recoil";
import { useEffect, useCallback } from "react";

// 認証エラーstate
const unauthorizedErrorState = atom({
  key: 'unauthorizedErrorState',
  default: null
});

export const useUnauthorizedError = () => {
  const [ unauthorizedError, setUnauthorizedError ] = useRecoilState(unauthorizedErrorState);

  useEffect(() => {
    // エラーがセットされていたら例外をthrowする
    if (unauthorizedError) {
      throw unauthorizedError;
    }
  }, [unauthorizedError]);

  const throwUnauthorizedError = useCallback((e) => {
    setUnauthorizedError(e);
  }, [setUnauthorizedError]);

  return {
    unauthorizedError, 
    throwUnauthorizedError
  };
};